import React from "react";

import { InternalLinkModel } from "@courses-pm2/api";

import { openInternalLink } from "@apps/viewer/src/ts/utils/openInternalLink";

type InternalLinkProps = {
    /**
     * The model contains the contents and the desired configurations of the
     * component.
     */
    model: InternalLinkModel;
};

/**
 * Internal links cannot be easily resolved within the course viewer, as they
 * are pointing within a portal - as such we'll need to open a new window and
 * point to the absolute link.
 */
export class InternalLink extends React.PureComponent<InternalLinkProps> {
    /**
     * Primary render method.
     */
    public render(): React.JSX.Element {
        return (
            <a
                className="internalLink"
                href="javascript:void()"
                onClick={this.onClick}
            >
                {this.props.model.render()}

                <style jsx>{`
                    a {
                        /** Apply font styling */
                        color: #dc4320;
                        text-decoration: none;

                        /** Apply hover styling */
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                `}</style>
            </a>
        );
    }

    /**
     * Listener that's triggered when the user clicks an internal link, making
     * sure that the link is going to be opened.
     */
    protected onClick = () => {
        const { model } = this.props;

        openInternalLink({
            path: model.href,
            portalId: model.portalId,
        })
            .catch(() => { /* Errors are handled internally, ignore silently... */ });
    }
}
